<div class="po-field-container-bottom">
    <span class="po-field-container-bottom-text-error"> 
        <span class=" an an-warning-circle po-field-container-icon-error"></span>
         {{text}}
    </span>  
</div>
